import { OptionsSettings } from './types';
import { Theme } from '../../../themeBase';

export const optionsSettings: OptionsSettings = {
  componentVariants: {
    selectVariant: {
      prop: 'selectVariant',
      variants: {
        primary: {
          fontWeight: 0,
          fontFamily: 'secondary',
          color: 'black.main',
          backgroundColor: 'white.main',
          boxShadow: (props: Theme) => props.boxShadows.input,
          '&::placeholder': {
            color: 'gray.main',
          },
        },
        secondary: {
          fontWeight: 600,
          fontFamily: 'secondary',
          color: 'black.main',
          backgroundColor: 'white.main',
          boxShadow: 'none',
          '&::placeholder': {
            color: 'gray.main',
          },
        },
      },
    },
    borderVariant: {
      prop: 'borderVariant',
      variants: {
        primary: {
          borderColor: 'gray.light',
          borderRadius: 3,
        },
      },
    },
    selectSize: {
      prop: 'selectSize',
      variants: {
        small: {
          fontSize: '0',
          lineHeight: '0',
          paddingTop: 2,
          paddingRight: 4,
          paddingBottom: 2,
          paddingLeft: 4,
        },
        medium: {
          fontSize: '1',
          lineHeight: '1',
          paddingTop: 3,
          paddingRight: 5,
          paddingBottom: 3,
          paddingLeft: 5,
        },
      },
    },
    optionVariant: {
      prop: 'optionVariant',
      variants: {
        primary: {
          backgroundColor: 'white.main',
          '&:hover': {
            backgroundColor: 'primary.extraLight',
          },
        },
        selected: {
          backgroundColor: 'primary.extraLight',
        },
      },
    },
  },
};
